import { render, staticRenderFns } from "./modalCapNhatChucVu.vue?vue&type=template&id=164b9534&"
import script from "./modalCapNhatChucVu.vue?vue&type=script&lang=js&"
export * from "./modalCapNhatChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports